export default "__VITE_ASSET__BH_D579m__"